// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createStoreCompanies = (client) => ({
    /**
     * `POST /store/companies`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-quote-management/src/api/store/companies/route.ts
     */
    create: (body, query, headers) => client.fetch("/store/companies", { method: "POST", body, query, headers }),
    /**
     * `POST /store/companies/:id/approval-settings`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-quote-management/src/api/store/companies/[id]/approval-settings/route.ts
     */
    createApprovalSetting: (id, body, query, headers) => client.fetch(buildPath("/store/companies/:id/approval-settings", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /store/companies/:id/employees`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-quote-management/src/api/store/companies/[id]/employees/route.ts
     */
    createEmployee: (id, body, query, headers) => client.fetch(buildPath("/store/companies/:id/employees", [id]), { method: "POST", body, query, headers }),
    /**
     * `DELETE /store/companies/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreCompanyDelete
     * @source packages/medusa-plugin-quote-management/src/api/store/companies/[id]/route.ts
     */
    delete: (id, body, query, headers) => client.fetch(buildPath("/store/companies/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `DELETE /store/companies/:id/employees/:employeeId`
     *
     * @operationId StoreCompaniesIdEmployeesEmployeeidDelete
     * @source packages/medusa-plugin-quote-management/src/api/store/companies/[id]/employees/[employeeId]/route.ts
     */
    deleteEmployee: (id, employeeId, body, query, headers) => client.fetch(buildPath("/store/companies/:id/employees/:employeeId", [id, employeeId]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /store/companies/:id/employees`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-quote-management/src/api/store/companies/[id]/employees/route.ts
     */
    listEmployees: (id, query, headers) => client.fetch(buildPath("/store/companies/:id/employees", [id]), { method: "GET", query, headers }),
    /**
     * `GET /store/companies/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreCompanyGet
     * @source packages/medusa-plugin-quote-management/src/api/store/companies/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/store/companies/:id", [id]), { method: "GET", query, headers }),
    /**
     * `GET /store/companies/:id/employees/:employeeId`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-quote-management/src/api/store/companies/[id]/employees/[employeeId]/route.ts
     */
    retrieveEmployee: (id, employeeId, query, headers) => client.fetch(buildPath("/store/companies/:id/employees/:employeeId", [id, employeeId]), { method: "GET", query, headers }),
    /**
     * `POST /store/companies/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreCompanyUpdate
     * @source packages/medusa-plugin-quote-management/src/api/store/companies/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/store/companies/:id", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /store/companies/:id/employees/:employeeId`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-quote-management/src/api/store/companies/[id]/employees/[employeeId]/route.ts
     */
    updateEmployee: (id, employeeId, body, query, headers) => client.fetch(buildPath("/store/companies/:id/employees/:employeeId", [id, employeeId]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=companies.js.map